/*
 * Trinom Digital Pvt Ltd ("COMPANY") CONFIDENTIAL                             *
 * Copyright (c) 2023 Trinom Digital Pvt Ltd, All rights reserved              *
 *                                                                             *
 * NOTICE:  All information contained herein is, and remains the property      *
 * of COMPANY. The intellectual and technical concepts contained herein are    *
 * proprietary to COMPANY and may be covered by Indian and Foreign Patents,    *
 * patents in process, and are protected by trade secret or copyright law.     *
 * Dissemination of this information or reproduction of this material is       *
 * strictly forbidden unless prior written permission is obtained from         *
 * COMPANY. Access to the source code contained herein is hereby forbidden     *
 * to anyone except current COMPANY employees, managers or contractors who     *
 * have executed Confidentiality and Non-disclosure agreements explicitly      *
 * covering such access.                                                       *
 *                                                                             *
 * The copyright notice above does not evidence any actual or intended         *
 * publication or disclosure of this source code, which includes               *
 * information that is confidential and/or proprietary, and is a trade secret, *
 * of COMPANY. ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC            *
 * PERFORMANCE, OR PUBLIC DISPLAY OF OR THROUGH USE OF THIS SOURCE CODE        *
 * WITHOUT THE EXPRESS WRITTEN CONSENT OF COMPANY IS STRICTLY PROHIBITED,      *
 * AND IN VIOLATION OF APPLICABLE LAWS AND INTERNATIONAL TREATIES. THE         *
 * RECEIPT OR POSSESSION OF THIS SOURCE CODE AND/OR RELATED INFORMATION DOES   *
 * NOT CONVEY OR IMPLY ANY RIGHTS TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS     *
 * CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT MAY DESCRIBE,    *
 * IN WHOLE OR IN PART.                                                        *
 *                                                                             *
 * File: \src\store\index.js                                                   *
 * Project: Telemedicine-MyMedicine                                            *
 * Created Date: Monday, April 3rd 2023, 11:20:44 am                           *
 * Author: Shyam Mohan <shyam@codestax.ai>                                     *
 * -----                                                                       *
 * Last Modified: June 7th 2024, 3:28:22 pm                                    *
 * Modified By: Prakersharya                                                   *
 * -----                                                                       *
 * Any app that can be written in JavaScript,                                  *
 *     will eventually be written in JavaScript !!                             *
 * -----                                                                       *
 * HISTORY:                                                                    *
 * Date         By  Comments                                                   *
 * --------------------------------------------------------------------------- *
 */

import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';
import bottomNavigationState from './bottomNavigationState';
import opdHospitalState from './opdHospitalState';
import opdPackageState from './opdPackageState';

import locationState from './locationState';
import particularHospitalState from './particularHospitalState';
import OPDPackageParticularHospitalState from './OPDPackageParticularHospitalState';
import OPDConfigCommonState from './OPDConfigCommonState';




Vue.use(Vuex);
const getDefaultState = () => {
  return {
    locale: "",
    name: "",
    employee: "",
    user_type: "",
    nurseBooking: {
      nurseType: 'Special Nurse',
      shiftType: 'Morning Shift',
      selectedDates: [],
      patientDetails: {},
      description: '',
      addressDetails: {},
      totalAmount: '',
      nurseSpecialtyDetails: ''
    },
    isDependentAllowed: false,
  }
};

export default new Vuex.Store({
  state: {
    locale: "",
    name: "",
    employee: "",
    user_type: "",
    nurseBooking: {
      nurseType: 'Special Nurse',
      shiftType: 'Morning Shift',
      selectedDates: [],
      patientDetails: {},
      description: '',
      addressDetails: {},
      totalAmount: '',
      nurseSpecialtyDetails: ''
    },
    isDependentAllowed: false,
  },
  mutations: {
    updateLocale(state, newLocale) {
      state.locale = newLocale;
    },
    updateName(state, newName) {
      state.name = newName;
    },
    updateEmployee(state, newEmployee) {
      state.employee = newEmployee;
    },
    updateDependency(state, isDependentAllowed) {
      state.isDependentAllowed = isDependentAllowed;
    },
    updateUserType(state, userType) {
      state.user_type = userType;
    },
    updateNurseType(state, nurseType){
      state.nurseBooking.nurseType = nurseType
    },
    updateShiftType(state, shiftType){
      state.nurseBooking.shiftType = shiftType
    },
    updateSelectedDates(state, selectedDates){
      state.nurseBooking.selectedDates = selectedDates
    },
    updatePatientDetails(state, patientDetails){
      state.nurseBooking.patientDetails = patientDetails
    },
    updateNurseBookingdescription(state, description){
      state.nurseBooking.description = description
    },
    updateAddressDetails(state,addressDetails){
      state.nurseBooking.addressDetails = addressDetails
    },
    updateAmountDetails(state, amountDetails){
      state.nurseBooking.totalAmount = amountDetails
    },
    updateNurseSpecialty(state, specialtyDetails){
      state.nurseBooking.nurseSpecialtyDetails = specialtyDetails
    },
    resetState(state) {
      Object.assign(state, getDefaultState());
    },
    resetNurseBookingValues(state){
      Object.assign(state.nurseBooking, getDefaultState().nurseBooking)
    }
  },
  actions: {
    changeLocale({ commit }, newLocale) {
      commit('updateLocale', newLocale);
    },
    changeName({ commit }, newName) {
      commit('updateName', newName);
    },
    changeEmployee({ commit }, newEmployee) {
      commit('updateEmployee', newEmployee);
    },
    changeDependency({ commit }, isDependentAllowed) {
      commit('updateDependency', isDependentAllowed);
    },
    changeUserType({ commit }, userType) {
      commit('updateUserType', userType);
    },
    changeNurseType({ commit }, nurseType) {
      commit('updateNurseType', nurseType);
    },
    changeShiftType({ commit }, shiftType) {
      commit('updateShiftType',shiftType)
    },
    changeSelectedDates({commit}, selectedDates) {
      commit('updateSelectedDates',selectedDates)
    },
    changePatientDetails({commit},PatientDetails){
      commit('updatePatientDetails',PatientDetails)
    },
    changeNurseBookingdescription({commit},description){
      commit('updateNurseBookingdescription',description)
    },
    changeAddressDetails({commit},addressDetails){
      commit('updateAddressDetails',addressDetails)
    },
    changeAmountDetails({commit}, totalAmount){
      commit('updateAmountDetails',totalAmount)
    },
    changeNurseSpecialty({commit}, specialtyDetails){
      commit('updateNurseSpecialty',specialtyDetails)
    },
    cleanNurseBookingValues({commit}){
      commit('resetNurseBookingValues');
    },
    cleanVuex({ commit }) {
      commit('resetState');
    }
  },
  getters: {
    nurseBookingHasValues(state){
      let defaultValues= getDefaultState().nurseBooking
      const isAnyPropertyDefault = Object.keys(defaultValues).some(key => {
        if(key === 'description', key === 'totalAmount') return false
        console.log(key)
        return state[key] === defaultValues[key];
      });
      return !isAnyPropertyDefault;
    }
  },
  modules: {
    bottomNavigationState: bottomNavigationState,
    opdHospitalState: opdHospitalState,
    opdPackageState: opdPackageState,
    locationState: locationState,
    particularHospitalState: particularHospitalState,
    OPDPackageParticularHospitalState,
    OPDConfigCommonState,
  },
  plugins: [createPersistedState()]
});
